import type { ReactElement } from "react";

import type { ApiData } from "../api/use-api-data.js";
import { NotFoundPage } from "../areas/account/message-pages.js";

import { loadFailureMessage } from "./load-failure.js";

/**
 * 画面の題名。<b>見つからなければ「見つからない」画面の題名にする</b>——
 * 画面が自分の題名を付け直すと、「見つからない」画面に別の題名が付く。
 */
export const titleFor = <T,>(data: ApiData<T>, title: string): string =>
    data.state === "failed" && data.status === 404 ? "ページが見つかりません" : title;

/**
 * 読み込み中・読めなかった・見つからなかった、の 3 つ。<b>読めたときだけ null</b>（画面が中身を描く）。
 *
 * <b>見つからない（404）は「見つからない」画面にする。</b>API は権限が無いときも 404 で断る
 * （存在を明かさない）。今のアプリの画面と同じ見た目になる。
 * <c>what</c> は読めなかったときに出す「何を」（「請求書」など）。
 */
export function ApiState<T>({ data, what }: {
    readonly data: ApiData<T>;
    readonly what: string;
}): ReactElement | null {
    if (data.state === "loading") {
        return <div className="page"><p className="text-slate-500">読み込んでいます…</p></div>;
    }
    if (data.state === "failed" && data.status === 404) {
        return <NotFoundPage />;
    }
    if (data.state === "failed") {
        return (
            <div className="page max-w-lg">
                <div className="alert-danger" role="alert">{loadFailureMessage(what, data)}</div>
            </div>
        );
    }
    return null;
}
